import { BehaviorSubject } from 'rxjs';
import { openModal, ModalProps, findModalByName } from '@core/components/ModalStack';
import { CallNotesModal as CNModal } from './CallNotesModal';
import { R } from '@core/utils/r';

export interface ActiveNote {
  phoneNumber: string;
  uuid: string;
}

export const activeCallNotes$ = new BehaviorSubject<ActiveNote[]>([]);
export interface CallModalProps extends ModalProps {
  phoneNumber: string;
}

export async function openCallNotesModal(props: { phoneNumber: string }) {
  const currentInstance = findModalByName('CallModal');
  if (!currentInstance) {
    const { CallNotesModal } = await import('./CallNotesModal');
    activeCallNotes$.next([{ phoneNumber: props.phoneNumber, uuid: R.uniqueId(props.phoneNumber) }]);
    openModal<typeof CNModal, CallModalProps>(CallNotesModal, props, {
      name: 'CallModal',
      id: R.uniqueId(props.phoneNumber),
      phoneNumber: props.phoneNumber,
    });
  } else if (!activeCallNotes$.value.find(n => n.phoneNumber === props.phoneNumber)) {
    activeCallNotes$.next([...activeCallNotes$.value, { phoneNumber: props.phoneNumber, uuid: R.uniqueId(props.phoneNumber) }]);
  }
}
